import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.667 6.667v18.666L25.333 16 10.667 6.667Z" }));
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
